var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 138.481,
    height: 43.244,
    viewBox: "0 0 138.481 43.244",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_11",
    "data-name": "Rectangle 11",
    width: 138.481,
    height: 43.244,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "logo",
    transform: "translate(0 -0.001)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_73",
    "data-name": "Groupe 73",
    transform: "translate(0 0.001)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_2",
    "data-name": "Trac\\xE9 2",
    d: "M107.475,24.532a6.536,6.536,0,0,1,3.977-1.145,18.454,18.454,0,0,1,4.614.433,4.775,4.775,0,0,0-.26-1.744c-.916-2.785-3.749-4.409-5.043-5.034a4.892,4.892,0,0,0-1.311-5.441,22.3,22.3,0,0,0-4.892-3.157c-2.107-1.177-3.839-2.142-4.876-3.617-.535-.757-1.3-2.165-1.3-2.165A7.523,7.523,0,0,0,97.153,5.8c-2.179-.841-4.415-3.284-5.057-4.045C91.407.941,90.767,0,90.767,0a9.371,9.371,0,0,0-1.021,6.069c-4.782-1.031-6.6-3.3-6.6-3.3a32.661,32.661,0,0,0-.152,8.239c.792,7,5.656,6.007,5.9,5.976a15.035,15.035,0,0,0-3.341,3.455A17.463,17.463,0,0,0,82.871,29c.066,3.186.648,3.524,1.182,3.6.448.066,1.1-.64,1.312-1.154a15.4,15.4,0,0,0,3.892,8.325c1.016,1.118,2.3,1.989,2.893,1.851.636-.15.921-2.418,1.229-3.389a10.169,10.169,0,0,1,3.361-4.982,13.86,13.86,0,0,0,1.791,6.861c1.561,2.277,3.68,3.129,4.358,2.418.259-.272.141-1.217-.149-1.83-.107-.221-.48-1.135-.669-1.705a10.951,10.951,0,0,0,6.531,1.943,11.78,11.78,0,0,0,4.059-.61c1.5-.522,2-1.158,1.952-1.49-.07-.452-.785-.946-1.834-1.26-2.617-.782-3.364-1.7-2.42-1.393a3.386,3.386,0,0,0,.932.177A1.711,1.711,0,0,0,113.12,34.6a10.845,10.845,0,0,0-.607-3.739,3.9,3.9,0,0,0-2.253-1.942c-3.482-.853-3.708-3.468-2.785-4.385",
    transform: "translate(22.348 -0.001)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_3",
    "data-name": "Trac\\xE9 3",
    d: "M95.656,25.678a6.166,6.166,0,0,0,3.736,2.381c.1.014.136,0,.151-.024s.01-.063-.046-.155a11.918,11.918,0,0,1-1.669-5.825c0-.342.013-.695-.163-.8-.183-.142-.5-.039-.907.159C93.8,22.853,89.02,27.2,89.7,33.526c.018.173.118.557.284.569.165-.011.2-.414.237-.615a8.583,8.583,0,0,1,.281-1.129,10.235,10.235,0,0,1,5.156-6.673",
    transform: "translate(24.191 5.718)",
    fill: "#002e62"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4",
    "data-name": "Trac\\xE9 4",
    d: "M112.7,35.806c-.014-.178-.282-.239-.483-.291-2.687-.69-8.367-3.467-8.226-9.984a5.976,5.976,0,0,1,3.421-5.4c1.977-1.031,4.888-.631,4.911-.825.009-.075-.1-.123-.4-.187-2.178-.461-10.983-2.311-18.165,1.016-.067.03-.428.17-.6.062-.217-.11-.165-.464-.159-.523a14.031,14.031,0,0,1,3.9-8.183c-12.779,2.9-13.277,12.9-13.1,15.9.011.211.117.323.208.323.123,0,.207-.137.268-.3a7.983,7.983,0,0,1,1.685-2.979,16.177,16.177,0,0,0,3.958,11.359c.055.06.29.287.475.2.135-.051.063-.414.057-.457-.838-5.422,1.788-13.955,11.9-15.422.2-.029.744-.146.876.088.133.255-.105.547-.185.684-2.478,4.241-.737,9.094.63,10.907.207.272.279.386.226.531-.038.13-.19.207-.481.226A8.475,8.475,0,0,1,98.222,30.6c-.227-.184-.437-.4-.528-.368-.1.048-.1.329-.081.574.255,3.727,1.488,5.906,3.56,7.514.06.047.291.178.39.075.071-.075-.029-.32-.07-.389a6.18,6.18,0,0,1-.862-4.2s4.24,4.4,11.606,2.292c.173-.048.48-.152.469-.3",
    transform: "translate(22.609 3.1)",
    fill: "#002e62"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5",
    "data-name": "Trac\\xE9 5",
    d: "M89.836,15a22.343,22.343,0,0,1,8.821-2.315c4.9-.293,9.378,1.041,10.955,3.393,1.826-6.135-9.718-7.136-11.358-11.5a5.142,5.142,0,0,0-.312,2.164c-2.931-.377-5.932-3.223-7.036-5.039a11.276,11.276,0,0,0,.06,5.118c-1.606.1-5.556-.531-7.223-2.222-.113,2.9.029,8,1.741,9.769,1.582,1.634,4.183.712,4.353.631",
    transform: "translate(22.593 0.459)",
    fill: "#dd1a18"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_6",
    "data-name": "Trac\\xE9 6",
    d: "M102.341,16.739c6.532.861,9.823,2.667,9.823,2.667-1.435-3.369-5.375-4.809-5.375-4.809-1.234-2.888-6.832-3.318-6.832-3.318a12.648,12.648,0,0,0-3.06.048,1.491,1.491,0,0,1-2.274,1.929l-.008-.008a11.687,11.687,0,0,0-1.686,3.873c-.006.027-.046.16.017.2a.248.248,0,0,0,.179,0,20.735,20.735,0,0,1,6.635-.862c.128.009.253.022.378.032a1.506,1.506,0,0,1,1.972-2.194,6.753,6.753,0,0,0-.338.9c-.177.516-.364.993-.217,1.044.3.1.823-.262,1.018-.834a1.376,1.376,0,0,0,.07-.583,1.5,1.5,0,0,1-.3,1.909",
    transform: "translate(25.075 3.026)",
    fill: "#002e62"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_7",
    "data-name": "Trac\\xE9 7",
    d: "M101.48,19.968s-3.534,3.768,2.564,8.526c1.685,1.314,3.271,1.765,3.3.651a7.753,7.753,0,0,0-.514-3.262,1.99,1.99,0,0,0-1.341-1.19c-1.605-.778-4.535-1.507-4.009-4.725",
    transform: "translate(27.114 5.388)",
    fill: "#a60009"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_8",
    "data-name": "Trac\\xE9 8",
    d: "M101.406,19.968,101.37,20a3.581,3.581,0,0,0-.461,3c1.211,3.214,5.408,6.123,6.283,4.555a6.4,6.4,0,0,0-.437-1.681,1.979,1.979,0,0,0-1.341-1.19c-1.605-.778-4.535-1.507-4.009-4.725",
    transform: "translate(27.188 5.388)",
    fill: "#dd1a18"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_9",
    "data-name": "Trac\\xE9 9",
    d: "M92.734,5.594a5.463,5.463,0,0,0,.18,2.249,10.756,10.756,0,0,1-7.793-1.081c-.177,1.683-.131,4.723,1.438,6.2a3,3,0,0,0,2.993.951.118.118,0,0,1,.025-.01,22.29,22.29,0,0,1,8.72-2.269c4.851-.291,9.289,1.016,10.906,3.326l0,0c-.789-4.144-7.472-4.742-12.807-6.987a9.991,9.991,0,0,1-3.666-2.385",
    transform: "translate(22.954 1.509)",
    fill: "#a60009"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_10",
    "data-name": "Trac\\xE9 10",
    d: "M2.958,19.053H7.266c.122,0,.19.067.19.2.013.433.013.855,0,1.355,0,.177-.069.23-.19.23H4.055c-.177,0-.27,0-.447-.244-.19-.283-.447-.663-.65-1V24.46H.695V16.546a.665.665,0,0,0-.055-.284L.071,14.907c-.081-.19,0-.244.081-.244H7.66c.122,0,.189.067.189.2.028.433.014.894,0,1.382,0,.177-.1.23-.189.23h-4.7Z",
    transform: "translate(0.01 3.956)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_11",
    "data-name": "Trac\\xE9 11",
    d: "M10.152,19.053h4.31c.122,0,.189.067.189.2.014.433.014.855,0,1.355,0,.177-.067.23-.189.23H11.25c-.177,0-.272,0-.447-.244-.19-.283-.448-.663-.651-1V24.46H7.889V16.546a.647.647,0,0,0-.055-.284l-.569-1.355c-.081-.19,0-.244.081-.244h7.508c.122,0,.19.067.19.2.027.433.013.894,0,1.382,0,.177-.1.23-.19.23h-4.7Z",
    transform: "translate(1.952 3.956)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_12",
    "data-name": "Trac\\xE9 12",
    d: "M21.778,20.516H18.105c-.177,0-.27-.014-.447-.244s-.434-.637-.637-.963v5.149H14.772v-9.8h2.249v4.051h4.757V14.662h2.249v9.8H21.778Z",
    transform: "translate(3.987 3.956)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_13",
    "data-name": "Trac\\xE9 13",
    d: "M24.713,16.478c-.135,0-.27.014-.284-.23-.014-.475-.014-.95,0-1.383,0-.136.067-.2.177-.2h3.848c2.805,0,3.673,1.749,3.673,3.821v5.476c0,.38-.189.5-.5.5H27.071c-1.9,0-3.686-.825-3.686-3.129,0-1.763,1.4-2.886,3.415-2.886h1.369a.527.527,0,0,1,.556.284,11.8,11.8,0,0,1,.813,1.219c.067.108.027.175-.067.175H27.179c-.921,0-1.4.516-1.4,1.208,0,.894.664,1.286,1.464,1.286h2.615V18.43c0-1.192-.3-1.952-1.722-1.952Z",
    transform: "translate(6.311 3.956)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_14",
    "data-name": "Trac\\xE9 14",
    d: "M32.131,16a.427.427,0,0,0-.1-.325l-.677-.8c-.109-.137-.042-.217.039-.217h2.345c.258,0,.392.189.555.38l4.946,5.948V14.663h1.939v9.8H39.828a.893.893,0,0,1-.8-.406l-4.96-5.935V24.46H32.131Z",
    transform: "translate(8.448 3.956)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_15",
    "data-name": "Trac\\xE9 15",
    d: "M45.066,14.663c2.886,0,5.069,1.449,5.069,4.77,0,3.483-2.249,5.027-4.893,5.027H41.271a.479.479,0,0,1-.5-.516V14.663Zm-.161,7.9c1.747,0,2.749-1.017,2.749-3.279,0-1.871-.841-2.806-2.508-2.806H43.02v5.868c0,.15.069.217.2.217Z",
    transform: "translate(11.004 3.956)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_16",
    "data-name": "Trac\\xE9 16",
    d: "M54.374,14.662c2.371,0,3.605,1.1,3.605,2.48A2.435,2.435,0,0,1,56.692,19.3,2.4,2.4,0,0,1,58.4,21.6c0,1.749-1.4,2.86-3.7,2.86H50.213a.525.525,0,0,1-.569-.583V16.547a.662.662,0,0,0-.055-.284l-.569-1.355c-.069-.164-.014-.245.081-.245Zm-.055,1.749H51.894v2.113H54.47a1.07,1.07,0,0,0,1.177-1.138c0-.583-.488-.975-1.327-.975m-2.425,3.754v2.25c0,.175.094.244.2.244h2.533a1.26,1.26,0,0,0,1.422-1.328c0-.611-.392-1.166-1.491-1.166Z",
    transform: "translate(13.222 3.956)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_17",
    "data-name": "Trac\\xE9 17",
    d: "M58.785,16.478c-.136,0-.272.014-.286-.23-.013-.475-.013-.95,0-1.383,0-.136.069-.2.177-.2h3.849c2.805,0,3.673,1.749,3.673,3.821v5.476c0,.38-.189.5-.5.5H61.143c-1.9,0-3.686-.825-3.686-3.129,0-1.763,1.4-2.886,3.415-2.886h1.369a.526.526,0,0,1,.555.284,11.8,11.8,0,0,1,.814,1.219c.069.108.027.175-.069.175h-2.29c-.922,0-1.4.516-1.4,1.208,0,.894.664,1.286,1.464,1.286h2.615V18.43c0-1.192-.3-1.952-1.721-1.952Z",
    transform: "translate(15.507 3.956)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_18",
    "data-name": "Trac\\xE9 18",
    d: "M67.978,22.292c0,.216.067.257.2.257h4.16a.183.183,0,0,1,.19.2c.014.434.014.989-.014,1.478-.014.244-.149.23-.325.23H67.219a1.4,1.4,0,0,1-1.49-1.572V14.663h2.249Z",
    transform: "translate(17.74 3.956)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_19",
    "data-name": "Trac\\xE9 19",
    d: "M74.065,22.292c0,.216.067.257.2.257h4.16a.182.182,0,0,1,.19.2c.013.434.013.989-.014,1.478-.013.244-.149.23-.325.23H73.307a1.4,1.4,0,0,1-1.492-1.572V14.663h2.25Z",
    transform: "translate(19.382 3.956)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.64d0d79f545f8791159f4de376d6e2d4.svg";
export { ForwardRef as ReactComponent };